import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
export function useSlotVisibility() {
    var headerStartVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.headerEnabled &&
            state.layout.slots[Slot.HEADER_START].enabled;
    });
    var headerCenterVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.headerEnabled &&
            state.layout.slots[Slot.HEADER_CENTER].enabled;
    });
    var headerEndVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.headerEnabled &&
            state.layout.slots[Slot.HEADER_END].enabled;
    });
    var headerVisible = headerStartVisible || headerCenterVisible || headerEndVisible;
    var footerStartVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.footerEnabled &&
            state.layout.slots[Slot.FOOTER_START].enabled;
    });
    var footerCenterVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.footerEnabled &&
            state.layout.slots[Slot.FOOTER_CENTER].enabled;
    });
    var footerEndVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.footerEnabled &&
            state.layout.slots[Slot.FOOTER_END].enabled;
    });
    var footerVisible = footerStartVisible || footerCenterVisible || footerEndVisible;
    var menuNorthVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.menuEnabled &&
            state.layout.slots[Slot.MENU_NORTH].enabled;
    });
    var menuWestVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.menuEnabled &&
            state.layout.slots[Slot.MENU_WEST].enabled;
    });
    var menuEastVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.menuEnabled &&
            state.layout.slots[Slot.MENU_EAST].enabled;
    });
    var dockWestVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.docksEnabled &&
            state.layout.slots[Slot.DOCK_WEST].enabled;
    });
    var dockEastVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.docksEnabled &&
            state.layout.slots[Slot.DOCK_EAST].enabled;
    });
    var dockNorthVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.docksEnabled &&
            state.layout.slots[Slot.DOCK_NORTH].enabled;
    });
    var dockSouthVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.docksEnabled &&
            state.layout.slots[Slot.DOCK_SOUTH].enabled;
    });
    var previewWestVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.previewEnabled &&
            state.layout.slots[Slot.PREVIEW_WEST].enabled;
    });
    var previewEastVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.previewEnabled &&
            state.layout.slots[Slot.PREVIEW_EAST].enabled;
    });
    var previewNorthVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.previewEnabled &&
            state.layout.slots[Slot.PREVIEW_NORTH].enabled;
    });
    var previewSouthVisible = useAppSelector(function (state) {
        return state.layout.areaEnabled &&
            state.layout.previewEnabled &&
            state.layout.slots[Slot.PREVIEW_SOUTH].enabled;
    });
    return {
        headerStartVisible: headerStartVisible,
        headerCenterVisible: headerCenterVisible,
        headerEndVisible: headerEndVisible,
        headerVisible: headerVisible,
        footerStartVisible: footerStartVisible,
        footerCenterVisible: footerCenterVisible,
        footerEndVisible: footerEndVisible,
        footerVisible: footerVisible,
        menuNorthVisible: menuNorthVisible,
        menuWestVisible: menuWestVisible,
        menuEastVisible: menuEastVisible,
        dockWestVisible: dockWestVisible,
        dockEastVisible: dockEastVisible,
        dockNorthVisible: dockNorthVisible,
        dockSouthVisible: dockSouthVisible,
        previewWestVisible: previewWestVisible,
        previewEastVisible: previewEastVisible,
        previewNorthVisible: previewNorthVisible,
        previewSouthVisible: previewSouthVisible,
    };
}
